"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketNotificationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketNotificationOutput.js.map